import { useMemo } from 'react';
import styles from './selectCard.scss';
import { ICreditCard } from 'types';
import useScrollOnMount from 'hooks/useScrollOnMount';

const CardToSelect = ({ selectedCard, selectCard, ac }) => {
  const handleSelect = () => selectCard(ac);
  const className = selectedCard
    ? classnames(
        styles.creditCard,
        selectedCard.name === ac.name ? styles.active : styles.blur,
      )
    : styles.creditCard;
  return (
    <div className={className} onClick={handleSelect}>
      <img src={`https:${ac.cardImageUrl}`} loading="lazy" height={'95px'} />
    </div>
  );
};

export interface ISelectCardProps {
  providerName: string;
  creditCards: ICreditCard[];
  selectedCard: ICreditCard;
  selectCard: (data: ICreditCard) => void;
}
const SelectCard = ({
  providerName,
  creditCards,
  selectedCard,
  selectCard,
}: ISelectCardProps) => {
  const ref = useScrollOnMount();

  const cards = useMemo(
    () => creditCards.filter((cc) => cc.providerName === providerName),
    [creditCards, providerName],
  );

  return (
    <div className={styles.selectCardContainer} ref={ref}>
      <div className={styles.creditCardsTitle}>Select your credit card</div>
      <div className={styles.creditCardsContainer}>
        {cards.map((c, idx) => {
          return (
            <CardToSelect
              key={c.id}
              ac={c}
              selectedCard={selectedCard}
              selectCard={selectCard}
            />
          );
        })}
      </div>
      {selectedCard && (
        <div className={styles.selectedCreditCardsTitle}>
          {selectedCard.name}
        </div>
      )}
    </div>
  );
};

export default SelectCard;
